import {HttpInterceptorFn} from '@angular/common/http';
import {inject} from '@angular/core';
import {TrackingIdService} from '../../services/tracking/tracking-id.service';

export const trackingIdInterceptor: HttpInterceptorFn = (req, next) => {
  if (typeof window === 'undefined') {
    return next(req);
  }

  const trackingIdService = inject(TrackingIdService);
  const trackingId = trackingIdService.getOrCreateTrackingId();

  return next(req.clone({
    setHeaders: {
      'X-Tracking-Id': trackingId,
    },
  }));
};
